import { Router, RouterModule } from '@angular/router';
import { Component, ElementRef, inject, OnInit, ViewEncapsulation } from '@angular/core';

import { UserService } from '@core/auth/user/user.service';
import { CommonModule, Location } from '@angular/common';
import { CdkDropDownModule } from '@core/customCDK/cdk-drop-down/cdk-drop-down.module';
import { GetTitleService } from '@core/services/get-title.service';
import { NotificationService } from '@page/notification/notification.service';
import { LogoutService } from '@core/auth/Logout.service';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CdkDropDownModule
  ],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {

  _LogoutService = inject(LogoutService);
  // currentTitle: string = '';
  pageTitle = this.titleService.currentTitle$;

  decData: any;
  count: any;
  constructor(
    private elRef: ElementRef,
    private _UserService: UserService,
    private titleService: GetTitleService,
    public notificationService: NotificationService,
    public _location: Location,
    public _Router: Router,
  ) {

  }

  ngOnInit(): void {
    // this.titleService.currentTitle$.subscribe((title) => {
    //   this.currentTitle = title;
    // });

    this.decData = this._UserService.loginData;
    // this.getNotifications();
  }

  menuadd() {
    this.elRef.nativeElement.parentElement.classList.toggle('toggled');
  }

  logout() {
    this._LogoutService.logout();
    // this.toaster.openSubmitConfirmationModal('Session Expired!!');   
  }
  // getNotifications() {
  // this.auth.getNotification(config.auth.getNotification).subscribe((responce: any) => {
  //   notificationCount.set(responce.data); // Update the signal with the new count
  // })
  // }


}
